export default "__VITE_ASSET__ec6ead8d__"